import getTheme from './theme';
import breakpoints from './breakpoints';
import { Breakpoints, Customization, Theme } from './types';

const makeTheme: (
    customization: Customization,
    customTheme: Partial<Theme>,
    customBreakpoints?: Breakpoints
) => Theme = (customization, customTheme, customBreakpoints = breakpoints) => {
    const defaultTheme = getTheme(customBreakpoints);

    return {
        ...defaultTheme,
        ...customTheme,
        customization,
    };
};

export default makeTheme;
